import { basic, act } from 'api';
import {
  UI_SET_LOADER,
  UI_SET_LOADER_TEXT,
  SET_UI_PROPERTY,
  GET_MARKDOWN_FILE,
  UI_GET_MASTER_DATA,
  UI_UPDATE_MASTER_DATA,
  UI_GET_CHEKINOUT_MASTER_DATA,
  UI_GET_TIRES_MASTER_DATA,
  UI_GET_MUNICIPALITIES
} from 'store/actions/ui';
import { userPartnerId } from 'helpers/user';

export default {
  [UI_GET_MASTER_DATA]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasMasterData) {
        act.getMasterData().then(
          resp => {
            commit(UI_UPDATE_MASTER_DATA, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),

  [UI_GET_CHEKINOUT_MASTER_DATA]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasCheckinoutMasterData) {
        act.getCheckinOutMasterData().then(
          resp => {
            commit(UI_GET_CHEKINOUT_MASTER_DATA, resp.data);
            userPartnerId().then(
              idPartner => {
                if (!idPartner) resolve(null);
                const storagePark = resp.data.storageParks.filter(
                  storage => storage.idParent === idPartner
                )[0];
                resolve(storagePark);
              },
              err => {
                commit('ERROR_OCCURRED', err, { root: true });
                reject();
              }
            );
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),

  [UI_GET_TIRES_MASTER_DATA]: ({ commit }, { filters, type }) =>
    new Promise((resolve, reject) => {
      if (filters.brand) {
        act.getTiresMasterData(filters).then(
          resp => {
            const data = resp.data;
            commit(UI_GET_TIRES_MASTER_DATA, { data, type });
            resolve();
          },
          err => {
            reject(err.response.data);
          }
        );
      } else {
        resolve();
      }
    }),

  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [UI_SET_LOADER_TEXT]: ({ commit }, text) => {
    commit(UI_SET_LOADER_TEXT, text);
  },

  [GET_MARKDOWN_FILE]: ({ commit, getters }, { url, field }) =>
    new Promise((resolve, reject) => {
      if (!getters.data(field)) {
        basic.getMarkdownFile(url).then(
          resp => {
            const data = resp.data;
            commit(SET_UI_PROPERTY, {
              field,
              value: data
            });
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),

  [UI_GET_MUNICIPALITIES]: ({ commit }, idProvince) =>
    new Promise((resolve, reject) => {
      act.getMunicipalities(idProvince).then(
        resp => {
          commit(UI_GET_MUNICIPALITIES, resp.data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    })
};
